import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HTTP_INTERCEPTORS, HttpClientXsrfModule, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { HttpXsrfInterceptor } from './core/interceptors/auth.header.interceptor';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from '@sparro/app/material.module';

import { FlexLayoutModule } from '@angular/flex-layout';
import { CookieService } from 'ngx-cookie-service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorComponent } from './modules/error/error.component';
import { HomeComponent } from './modules/home/home.component';
import { DetailComponent } from './modules/detail/detail.component';
import { ShareModule } from 'ngx-sharebuttons';
import { CoreModule } from '@journal/app/core/core.module';

import { UNIAppModule } from '@sparro/app/app.module';
// import { UNISharedModule } from '@sparro/app/shared/shared.module';
import { LayoutModule } from '@sparro/app/shared/components/layout/layout.module';
import { CardsModule } from '@sparro/app/shared/components/cards/cards.module';
import { LoaderModule } from '@sparro/app/shared/components/loader/loader.module';
import { ButtonsModule } from '@sparro/app/shared/components/buttons/buttons.module';
import { ImagesModule } from '@sparro/app/shared/components/images/images.module';
import { PanelModule } from '@sparro/app/shared/components/panel/panel.module';
import { CommentsModule } from '@sparro/app/shared/components/comments/comments.module';
import { PipesModule } from '@sparro/app/shared/pipes/pipes.module';
import { SearchModule } from './modules/search/search.module';
import { JournalCommonModule } from './modules/journal-common/journal-common.module';

import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import 'froala-editor/js/plugins.pkgd.min.js';
// import { NavigationButtonComponent } from '@sparro/app/shared/components/buttons/blueprints/navigation-button/navigation-button.component';

@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent,
    HomeComponent,
    DetailComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    HttpClientModule,
    MaterialModule,
    FlexLayoutModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'csrftoken',
      headerName: 'X-CSRFToken'
    }),
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    UNIAppModule.forRoot(),
    // UNISharedModule,
    LayoutModule,
    CardsModule,
    ButtonsModule,
    LoaderModule,
    ImagesModule,
    PanelModule,
    CommentsModule,
    SearchModule,
    PipesModule,
    ShareModule,
    JournalCommonModule
  ],
  providers: [
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpXsrfInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
